// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".combo-list-wrapper .combo-item.combo-item-transparent .item-img-transparent{height:75%;margin:auto}.combo-list-wrapper .combo-item.combo-item-transparent .item-images i.prz-plus{background:#333;color:#fff}", ""]);
// Exports
module.exports = exports;
